import { Routes } from '@angular/router';

import { VANILLA_LAZY_ROUTES } from '@frontend/loaders/routes';
import { ClientConfigProductName } from '@frontend/vanilla/core';

import { lastKnownProductRedirectFunction } from '../guards';

export const defaultRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: lastKnownProductRedirectFunction,
    },
    {
        path: 'maintenance/:product',
        loadComponent: () => import('../maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
        data: { vanillaRoute: true },
    },
    {
        path: 'p',
        loadChildren: () => import('@frontend/vanilla/features/public-page').then((m) => m.ROUTES),
        data: {
            publicPageRoot: 'MobilePortal-v1.0/PublicPages/',
            product: ClientConfigProductName.PORTAL,
        },
    },
    {
        path: 'server-error',
        loadChildren: () => import('@frontend/vanilla/features/server-error').then((m) => m.ROUTES),
    },
    {
        path: '',
        children: [...VANILLA_LAZY_ROUTES],
        data: { vanillaRoute: true },
    },
    {
        path: 'apps',
        loadChildren: () => import('../apps/routes').then((t) => t.ROUTES),
    },
];
